import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { GameProvider } from './context/GameContext';
import Home from './components/Home';
import TopicSelection from './components/TopicSelection';
import LearningModule from './components/LearningModule';
import TerraformSimulator from './components/TerraformSimulator';
import BashScriptSimulator from './components/BashScriptSimulator';
import VimSimulator from './components/VimSimulator';
import ScenarioChallenge from './components/ScenarioChallenge';
import XPBar from './components/XPBar';
import AchievementPopup from './components/AchievementPopup';
import XPGainPopup from './components/XPGainPopup';
import './App.css';

// Component to conditionally show XP bar
const AppContent = () => {
  const location = useLocation();
  const showXPBar = location.pathname !== '/';

  return (
    <div className="App">
      {showXPBar && <XPBar />}
      <AchievementPopup />
      <XPGainPopup />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/topics" element={<TopicSelection />} />
        <Route path="/learn/:topic" element={<LearningModule />} />
        <Route path="/terraform-simulator" element={<TerraformSimulator />} />
        <Route path="/bash-simulator" element={<BashScriptSimulator />} />
        <Route path="/vim-simulator" element={<VimSimulator />} />
        <Route path="/scenario/:topic" element={<ScenarioChallenge />} />
        <Route path="/scenario/:topic/:scenarioId" element={<ScenarioChallenge />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <GameProvider>
      <Router>
        <AppContent />
      </Router>
    </GameProvider>
  );
}

export default App;
